import React from "react";

import jwt from "jsonwebtoken";
import { getServiceUrl, GetWARPUrl } from "../config";
import axios from "axios";
import { Redirect, withRouter } from "react-router-dom";
import { Component } from "react";
import { popupAlert } from "../UI/Popups/popup";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Spinner from "../UI/Spinner/Spinner";
import Button from "../components/Material/CustomButtons/Button";
import SparkleIcon from "../assets/img/jsIcons/SparkleIcon";

const WARP_Link = GetWARPUrl();
let messageData = "";

class DocumentRepositoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authGenerated: false,
      loading: false,
      open: false,
      iframeHeight: 60,
      configId: "",
      documentLogsId: "",
      fileUrl: "",
      cardArray: [],
      duplicateFilesData: [{ title: "", originalFileName: "" , documentLogsId: "" }],
      filesData: [],
      deletedByUserName: "",
      deletedFileDate: "",
      dropzoneConfig: {},
      commonDialog: { isOpened: false },
      ratingTitle: "",
      documentName: "",
      documentUrl: "",
      ratingContent: "",
      recommendations: [],
      rating: "",
    };
    this.newHandle = this.newHandle.bind(this);
    this.parentClickListener = null;
    this.handleIframeMessage = this.handleIframeMessage.bind(this);
  }
  _isMounted = false;
  newHandle = async (event) => {
     let messageData;
  const dataType = typeof event.data;

  if (dataType === 'string') {
    try {
      messageData = JSON.parse(event.data);
    } catch (err) {
      console.warn('parent: received string but not JSON:', event.data);
      return;
    }
  } else if (dataType === 'object') {
    messageData = event.data;
  } else {
    // unknown shape
    console.warn('parent: unexpected event.data type', dataType, event.data);
    return;
  }

  if (!messageData || !messageData.type) {
    console.warn('parent: message missing type or empty', messageData);
    return;
  }

      try {
        const type = messageData.type;
        console.log("Parent received message:", messageData);
        switch (type) {
            case "warp-content-resize":
              if (
                this.state.iframeHeight !== messageData.data.height &&
                this.state.open === false
              ) {
                this.setState({ iframeHeight: messageData.data.height + 50 });
              }
              break;
          case "ratingCardText_Popup":
            this.setState({
              ratingTitle: messageData.data.ratingTitle,
              documentName: messageData.data.documentName,
              documentUrl: messageData.data.documentUrl,
              ratingContent: messageData.data.ratingContent,
              recommendations: messageData.data.recommendations || [],
              rating: messageData.data.rating,
              commonDialog: {
                isOpened: true,
                popupTitle: "ratingCardText",
              },
            });
            break;
          case "document-repository-delete-file-modal":
            this.setState({
              configId: messageData.data.configId,
              documentLogsId: messageData.data.documentLogsId,
              fileUrl: messageData.data.fileUrl,
              cardArray: messageData.data.cardArray,
              status: messageData.data.status,
            });
            {
              popupAlert(
                "deleteFileConfirmWarpPopup",
                `Delete "${messageData.data.fileName}"?`,
                "This file will be permanently removed from the repository.",
                () => {
                  let sendRemoveData = document.getElementById("listIframe");
                  sendRemoveData.contentWindow.postMessage(
                    JSON.stringify({
                      type: "document-repository-delete-file-from-modal-true",
                      configId: this.state.configId,
                      documentLogsId: this.state.documentLogsId,
                      fileUrl: this.state.fileUrl,
                      cardArray: this.state.cardArray,
                      status: this.state.status,
                    }),
                    "*"
                  );
                },
                "No, Keep File",
                "Yes, Delete"
              );
              break;
            }
          case "document-repository-duplicate-document-modal":
            this.setState({
              duplicateFilesData: messageData.data.duplicateFilesData,
              filesData: messageData.data.fileDataArray,
              configId: messageData.data.configId,
              isOther: messageData.data.isOther,
              docTitle: messageData.data.docTitle,
            });
            {
              popupAlert(
                "deleteConfirmWarpPopup",
                <div>
                  <h6>File already exists</h6>
                  <p>
                    A file named {this.state.duplicateFilesData.map(file => file.originalFileName).join(", ")} already exists in {this.state.isOther ? "your Document Repository" : this.state.duplicateFilesData[0].title}.<br />
                    Do you want to replace it with the new file{this.state.isOther ? "" : " in" + this.state.docTitle}?
                  </p>
                </div>,
                "",
                () => {
                  let sendRemoveData = document.getElementById("listIframe");
                  sendRemoveData.contentWindow.postMessage(
                    {
                      type: "document-repository-duplicate-document-modal-true",
                      duplicateFilesData: this.state.duplicateFilesData,
                      configId: this.state.configId,
                      isOther: this.state.isOther,
                      docTitle: this.state.docTitle,
                      filesData: this.state.filesData,
                    },
                    "*"
                  );
                },
                "CANCEL",
                "REPLACE"
              );
              break;
            }
           case "document-repository-reject-already-deleted-file-message":
            this.setState({
              deletedByUserName: messageData.data.deletedByUserName,
              deletedFileDate: messageData.data.deletedFileDate,
              configId: messageData.data.configId,
              dropzoneConfig: messageData.data.dropzoneConfig,
            });
            {
              popupAlert(
                "deleteFileConfirmWarpPopup",
                "Document Deletion Failed",
                `This document has already been deleted by ${this.state.deletedByUserName} on ${this.state.deletedFileDate}.`,
                 () => {
                  let sendRemoveData = document.getElementById("listIframe");
                  sendRemoveData.contentWindow.postMessage(
                    {
                      type: "document-repository-reject-already-deleted-file-message-true",
                      deletedByUserName: this.state.deletedByUserName,
                      deletedFileDate: this.state.deletedFileDate,
                      dropzoneConfig: this.state.dropzoneConfig,
                      configId: this.state.configId,
                    },
                    "*"
                  );
                },
                "CLOSE",
                "OKAY",               
              );
              break;
            }
        }
      } catch (error) {}
  };
  async GetAuthToken() {
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.tokenId,
        "Content-Type": "application/json",
        emailId: localStorage.emailId,
      },
    };
    await axios
      .get(getServiceUrl() + "warp/GetAuthToken", config)
      .then((json) => {
        // console.log({ json });
        localStorage.setItem("warpToken", json.data);
        this.setState({ authGenerated: true });
      })
      .catch((err) =>
        err.response !== undefined
          ? err.response.status === 401
            ? (window.location.pathname = "/logout")
            : ""
          : ""
      );
  }
  async componentDidMount() {
    if (
      localStorage.warpToken === undefined &&
      localStorage.warpToken === "null"
    ) {
      this.GetAuthToken();
    }
    this.setState({ loading: true });
    window.addEventListener("message", this.newHandle);
    window.addEventListener('message', this.handleIframeMessage);
  }

  componentWillUnmount() {
    // Clean up message listener
    window.removeEventListener('message', this.handleIframeMessage);
    
    // Clean up click listener
    if (this.parentClickListener) {
      document.removeEventListener('click', this.parentClickListener, true);
    }
  }

  handleIframeMessage = (event) => {
    if (event.data && typeof event.data === 'object') {
      // Handle setup click listener request from iframe
      if (event.data.type === 'SETUP_CLICK_LISTENER') {
        console.log(`Setting up click listener for: ${event.data.source}`);
        
        // Create the click handler
        const handleParentClick = (e) => {
          // Check if click is outside the iframe
          const iframes = document.querySelectorAll('iframe');
          let clickedOutsideIframe = true;
          
          iframes.forEach(iframe => {
            const rect = iframe.getBoundingClientRect();
            const clickX = e.clientX;
            const clickY = e.clientY;
            
            if (clickX >= rect.left && clickX <= rect.right && 
                clickY >= rect.top && clickY <= rect.bottom) {
              clickedOutsideIframe = false;
            }
          });
          
          if (clickedOutsideIframe) {
            // Notify all iframes about outside click
            iframes.forEach(iframe => {
              try {
                iframe.contentWindow.postMessage({
                  type: 'PARENT_CLICK_OUTSIDE',
                  source: 'parent-window'
                }, '*');
              } catch (e) {
                console.log('Cannot send message to iframe:', e);
              }
            });
          }
        };
        
        // Remove existing listener if any
        if (this.parentClickListener) {
          document.removeEventListener('click', this.parentClickListener, true);
        }
        
        // Add new listener with capture phase
        this.parentClickListener = handleParentClick;
        document.addEventListener('click', handleParentClick, true);
      }
    }
  }

  handleCommonDialogClose = () => {
    this.setState({
      commonDialog: { isOpened: false },
      qwcopen: false,
    });
  };

  render() {
    //changes token expiry
    if (
      localStorage.warpToken !== undefined &&
      localStorage.warpToken !== null &&
      localStorage.warpToken !== ""
    ) {
      var now = new Date();
      const todaydate = new Date(
        now.getTime() + now.getTimezoneOffset() * 60000
      );

      const token = jwt.decode(localStorage.warpToken);
      const tokendate = new Date(0);

      if (token != null) {
        tokendate.setUTCSeconds(token.exp);
      }

      const tokendateiat = new Date(0);
      if (token != null) {
        tokendateiat.setUTCSeconds(token.iat);
      }

      if (todaydate > tokendate) {
        //  if (houriat < endhour + 5 ) {
        // console.log("token expired!");
        return <Redirect to="/logout" />;
      }
    }
    let ChildIframeUrl =
      WARP_Link +
      "document-repository?accessToken=" +
      (localStorage.getItem("warpToken") || "");

    const actionParams = new URLSearchParams(window.location.search).get("action");
    if (actionParams === 'document-logs') {
      ChildIframeUrl = WARP_Link + "document-repository?action=" + actionParams + "&accessToken=" + (localStorage.getItem("warpToken") || "")
    }

    return (
      <React.Fragment>
        <iframe
          allow
          title=" "
          id="listIframe"
          src={ChildIframeUrl}
          allowFullScreen
          frameBorder="0"
          style={{ minHeight: "500px", width: "100%" }}
          height={this.state.iframeHeight}
          loading="eager"
        />
        <Dialog
          open={
            this.state.commonDialog.isOpened &&
            this.state.commonDialog.popupTitle === "ratingCardText"
          }
          onClose={this.handleCommonDialogClose}
          fullWidth={true}
          TransitionComponent={this.Transition}
          transitionDuration={900}
          maxWidth="sm"
          PaperProps={{ className: "rating_popup_block" }}
        >
          <DialogTitle
            id="scroll-dialog-title"
            className="rating_popup_heading"
          >
            {this.state.ratingTitle}
            <IconButton
              className="closebtn"
              aria-label="close"
              onClick={this.handleCommonDialogClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            className="rating_popup_block_content"
          >
            {this.state.qwcloader ? <Spinner style={{ minHeight: 100 }} /> : ""}
            <div className="rating_doc_rate_block">
              <p>Document : <a href={this.state.documentUrl} target="_blank" rel="noopener noreferrer">{this.state.documentName}</a></p><div className="ratingButton"><SparkleIcon/> RATING : {this.state.rating}</div>
            </div>
            <div className="scrolledContent">
                {this.state.ratingContent && (
                  <div className="assessment_section">
                    <p><strong>Assessment:</strong> <span
                      dangerouslySetInnerHTML={{
                        __html: this.state.ratingContent || "",
                      }}
                    /></p>
                  </div>
                )}
                {this.state.recommendations && Array.isArray(this.state.recommendations) && this.state.recommendations.length > 0 && (
                  <div className="recommendations_section">
                    <h3>Recommendations for Improvement</h3>
                    <ul className="recommendations_list">
                      {this.state.recommendations.map((recommendation, index) => (
                        <li key={index}>{recommendation}</li>
                      ))}
                    </ul>
                  </div>
                )}
            </div>
            <Button
              style={{ marginRight: 24 }}
              className="outline_btn_new"
              onClick={this.handleCommonDialogClose}
            >
              CLOSE
            </Button>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default withRouter(DocumentRepositoryPage);
